/**
 * Country Card (used on homepage country groups and country post prev/next)
 */

import React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const CountryCard = ({ country, rel, description, title }) => {
  const countryName = title || country.title
  const image = {
    src: country.featuredImage?.node?.localFile
      ? getImage(country.featuredImage?.node?.localFile)
      : null,
    alt: country.featuredImage?.node?.altText || ``,
  }
  return (
    <article data-sal="zoom-out" data-sal-delay="300">
      <div className="country-card rounded bg-gray-200 print:max-w-md print:bg-transparent print:border print:border-gray-300 print:shadow-none print:my-4 overflow-hidden transform shadow hover:shadow-lg transition hover:scale-105 block">
        <Link to={country.uri} className="link-plain" itemProp="url" rel={rel}>
          <div className="w-full h-44 sm:h-52 xl:h-60 relative">
            <div className="h-full absolute w-full inset-0">
              {image?.src ? (
                <GatsbyImage
                  image={image.src}
                  className="w-full h-full"
                  objectFit="cover"
                  alt={image.alt}
                />
              ) : (
                <div className="bg-gray-200"></div>
              )}
            </div>
            <div className="relative h-full flex items-end">
              <div className="p-4 bg-white bg-opacity-90 inline-block m-4">
                {description && (
                  <div className="pb-2  leading-tight">{description}</div>
                )}
                {countryName && (
                  <div className="font-bold leading-tight">
                    {parse(countryName)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </article>
  )
}

CountryCard.defaultProps = {
  rel: ``,
  description: ``,
}

export default CountryCard
